export const extractOutputIntents = (obj) => {
  const result = {};
  if (!obj) return result;
  Object.keys(obj).forEach((key) => {
    if (key === 'output_intent' || key.startsWith('output_intent_')) {
      result[key] = obj[key];
    }
  });
  return result;
};
